import {
  Button as HeadlessButton,
  type ButtonProps as HeadlessButtonProps,
} from "@headlessui/react";
import { Close } from "@winamp/icons/Close.js";
import { forwardRef, useContext } from "react";
import { classNames } from "../../utils/classNames";
import { TouchTarget } from "../TouchTarget";
import { MessageContext } from "./Message";

export const MessageClose = forwardRef<HTMLElement, HeadlessButtonProps>(
  function MessageClose({ className, ...props }, ref) {
    const context = useContext(MessageContext) ?? {};
    if (!context) {
      throw new Error("MessageClose must be used within a Message");
    }

    return (
      <HeadlessButton
        {...props}
        role="button"
        className={classNames(
          [
            "h-fit transition-colors cursor-default rounded-sm bg-[--btn-bg]",
            "data-[active]:bg-overlay data-[hover]:bg-overlay",
            "focus:outline-none data-[focus]:outline data-[focus]:outline-2 data-[focus]:outline-offset-2 data-[focus]:outline-blue-500",
            "disabled:opacity-35 data-[disabled]:opacity-35",
          ],
          className,
        )}
        ref={ref}
      >
        <TouchTarget>
          <Close className="size-5" />
        </TouchTarget>
      </HeadlessButton>
    );
  },
);
